module.exports = __webpack_public_path__ + "static/img/Marcus_Bontempelli_mobile.7b68446.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Marcus_Bontempelli_mobile.jpg
// module id = LLCz
// module chunks = 0